import PropTypes from 'prop-types';
import ConnectionListItem from './connectionListItem';
import Icon from '../../../icon';
import connectionType, { connectionsPropTypes } from '../../../../utils/connections/connectionType';

export default function ConnectionsBox({ connections }) {
  return (
    <div className="connections-box">
      <Icon.Connection width={20} />
      <div className="connections-content">
        This article cites:
        <ul className="connections-list">
          <ConnectionListItem
            count={connections[connectionType.citesYourPaper]?.length}
            description="written by you"
            type={connectionType.citesYourPaper}
            id="cites-your-paper"
          />
          <ConnectionListItem
            count={connections[connectionType.citesYourCitation]?.length}
            description="that you cited"
            type={connectionType.citesYourCitation}
            id="cites-your-citation"
          />
          <ConnectionListItem
            count={connections[connectionType.citesCoAuthor]?.length}
            description="written by your co-author"
            type={connectionType.citesCoAuthor}
            id="cites-co-author"
          />
          <ConnectionListItem
            count={connections[connectionType.citesYourCiter]?.length}
            description="that cited you"
            type={connectionType.citesYourCiter}
            id="cites-your-citer"
          />
        </ul>
      </div>
    </div>
  );
}

ConnectionsBox.propTypes = {
  connections: PropTypes.shape(connectionsPropTypes).isRequired,
};
